const categories = [
  {
    id: "cables",
    name: "Kabel",
    items: [
      {
        id: "c1",
        code: "110 005 05",
        name: "1x10mm² Black Ring 100m",
        image: "/images/brikne.jpg",
      },
      {
        id: "c2",
        code: "110 005 84",
        name: "1x10mm² Blue Ring 100m²",
        image: "/images/brikne.jpg",
      },
      {
        id: "c3",
        code: "110 005 24",
        name: "1x10mm² G/Y Ring 100m",
        image: "/images/brikne.jpg",
      },
      {
        id: "c4",
        code: "110 005 06",
        name: "1x16mm² Black Ring 100m",
        image: "/images/brikne.jpg",
      },
      {
        id: "c5",
        code: "110 006 65",
        name: "1x16mm² Brown Ring 100m",
        image: "/images/brikne.jpg",
      },
    ],
  },
  {
    id: "Hülse",
    name: "Hülse",
    items: [
      {
        id: "f1",
        code: "051 010 91",
        name: "Hülse 6mm²/12",
        image: "/images/hilzna_y.jpg",
      },
      {
        id: "f2",
        code: "051 010 57",
        name: "Hülse 10mm²/12",
        image: "/images/hilzna_r.jpg",
      },
      {
        id: "f3",
        code: "051 010 58",
        name: "Hülse 10mm²/18",
        image: "/images/hilzna_r.jpg",
      },
      {
        id: "f4",
        code: "051 010 75",
        name: "Hülse 16mm²/12",
        image: "/images/hilzna_b.jpg",
      },
      {
        id: "f5",
        code: "051 010 76",
        name: "Hülse 16mm²/18",
        image: "/images/hilzna_b.jpg",
      },
    ],
  },
  {
    id: "Other",
    name: "Other",
    items: [
      {
        id: "OKK",
        code: "014 002 64",
        name: "Hager EHZ001K OKK",
        image: "/images/OKK.jpg",
      },
      {
        id: "APZBOX",
        code: "014 015 25",
        name: "HENSEL Mi 2279 APZ-Housing",
        image: "/images/APZBOX.jpg",
      },
      {
        id: "klemme",
        code: "051 045 99",
        name: "Klemme 1P Gray",
        image: "/images/klemme1Pg.jpg",
      },
      {
        id: "klemmeb",
        code: "051 046 00",
        name: "Klemme 1P Blue",
        image: "/images/klemme1Pb.jpg",
      },
      {
        id: "klemmeg",
        code: "051 046 01",
        name: "Klemme 1P Green",
        image: "/images/klemme1Pgy.jpg",
      },
    ],
  },
];

export default categories;
